import React from "react";
import { capitalize, formatDate } from "../utils";

export default function SubscriptionTable({
    subscriptions,
    loadingSubs,
    subsError,
    onView,
}) {
    return (
        <div className="w-full mb-6">
            <table className="min-w-full text-xs">
                <thead>
                    <tr className="bg-gray-100 text-black">
                        <th className="py-3 px-4 text-left font-medium">Subscription</th>
                        <th className="py-3 px-4 text-center font-medium">Status</th>
                        <th className="py-3 px-4 text-center font-medium">Next Payment</th>
                        <th className="py-3 px-4 text-center font-medium">Total</th>
                        <th className="py-3 px-4 text-center font-medium">Actions</th>
                    </tr>
                </thead>

                <tbody>
                    {loadingSubs && (
                        <tr>
                            <td colSpan={5} className="py-6 text-center text-gray-500">
                                Loading subscriptions...
                            </td>
                        </tr>
                    )}

                    {!loadingSubs && subsError && (
                        <tr>
                            <td colSpan={5} className="py-6 text-center text-red-500">
                                {subsError}
                            </td>
                        </tr>
                    )}

                    {!loadingSubs &&
                        !subsError &&
                        subscriptions.map((sub, index) => (
                            <tr key={index} className="border-b border-gray-200">
                                <td className="py-4 px-4 font-medium text-black">
                                    #{sub?.subscription_id}
                                </td>

                                <td className="py-4 px-4 text-center font-medium text-black">
                                    {capitalize(sub?.status)}
                                </td>

                                <td className="py-4 px-4 text-center text-black">
                                    {formatDate(sub?.next_payment)}
                                </td>

                                <td className="py-4 px-4 text-center font-medium text-black">
                                    ₹{sub?.total}
                                </td>

                                <td className="py-4 px-4 text-center">
                                    <button
                                        onClick={() => onView(sub)}
                                        className="text-blue-400 border border-blue-300 rounded px-4 py-1 hover:bg-blue-50 transition-colors"
                                    >
                                        View
                                    </button>
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
        </div>
    );
}
